// src/components/shared/other/tabGroup.tsx
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export interface Tab {
    id: string;
    label: string;
}

interface TabGroupProps {
    tabs: Tab[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
    variant?: 'primary' | 'secondary';
    className?: string;
}

export function TabGroup({
                             tabs,
                             activeTab,
                             onTabChange,
                             variant = 'primary',
                             className
                         }: TabGroupProps) {
    const isPrimary = variant === 'primary';

    return (
        <RadioGroup
            className={cn(
                "inline-flex p-1 rounded-lg w-full md:w-auto",
                isPrimary ? "bg-slate-100" : "bg-slate-50",
                className
            )}
            value={activeTab}
            onValueChange={onTabChange}
        >
            {tabs.map((tab) => (
                <div key={tab.id} className="relative flex-1 md:flex-initial">
                    <RadioGroupItem
                        value={tab.id}
                        id={tab.id}
                        className="peer sr-only"
                    />
                    <Label
                        htmlFor={tab.id}
                        className={cn(
                            "block text-center px-4 py-2 rounded-md cursor-pointer transition-colors",
                            "peer-data-[state=checked]:text-white relative z-10",
                            !isPrimary && "text-sm"
                        )}
                    >
                        {tab.label}
                    </Label>
                    {activeTab === tab.id && (
                        <motion.div
                            className={cn(
                                "absolute inset-0 rounded-md",
                                isPrimary ? "bg-slate-900" : "bg-slate-700"
                            )}
                            layoutId={`tab-background-${variant}`}
                            transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                        />
                    )}
                </div>
            ))}
        </RadioGroup>
    );
}
